import React, { useEffect, useState } from 'react';
import { sharedTableStyles } from '../../utils/tableStyles';
import { TableSkeleton } from '../../components/UI/Skeleton/Skeleton';
import TableCard from '../../components/UI/TableToolbar/TableCard';
import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import DataTable from 'react-data-table-component';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';

import {
  useGetEmployeesLOPQuery,
  useUpdateLopCorrectionMutation
} from '../../redux/apis/payrollApi';

import PageHeader from '../../components/common/PageHeader';
import EmptyData from '../../components/UI/EmptyData';

import { notification } from '../../utils/notification';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import { updateLopFormSchema, updateOvertimeFormSchema } from '../../utils/schemas/payrun';
import { LB_PAYRUN_TABLE_COLS } from '../../utils/constant/labels';
import { getErrorMessage, handleApiError } from '../../utils/handler';
import { INPUT_LABEL, PLACEHOLDER } from '../../utils/constant/placeHolders';
import {
  //GLOBAL,
  KPI_START_YEAR,
  CALENDAR_MONTHS,
  PAYROLL_CATEGORY
} from '../../utils/constant/global';
import { handleYearChange, setSelectedPayrunTab } from '../../redux/Slice/payrunSlice';
import './Payrun.scss';

// const { LOADING } = GLOBAL;
const { BTN_SAVE } = BT_BUTTON_LABELS;
const { LOP, OVERTIME } = PAYROLL_CATEGORY;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { LB_TBL_COL_ACTION, LB_TBL_COL_MONTH } = LB_PAYRUN_TABLE_COLS;
const { PH_CORRECTION_LOP, PH_CORRECTION_OVERTIME, PH_LOP, PH_OVERTIME, PH_CORRECTION_NOTES } =
  PLACEHOLDER;
const { LB_CORRECTION_LOP, LB_CORRECTION_OVERTIME, LB_CORRECTION_NOTES, LB_LOP, LB_OVERTIME } =
  INPUT_LABEL;

const payrunTableStyles = {
  ...sharedTableStyles,
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      color: '#6b7280',
      fontWeight: 600
    }
  }
};

const initialState = {
  row: null,
  year: null,
  month: null,
  loading: false,
  startDate: null,
  endDate: null,
  employeesLopList: [],
  selectedLOPData: null,
  selectedLopModel: false
};

const getMonthView = (row) => {
  const year = new Date().getFullYear();
  return {
    row,
    year,
    startDate: new Date(year, row?.id, 1, 0, 0, 0, 0).getTime(),
    endDate: new Date(year, row?.id + 1, 0, 23, 59, 59, 999).getTime(),
    month: row?.id + 1
  };
};

const Payrun = () => {
  const dispatch = useDispatch();
  const { currentYear, selectedPayrunTab } = useSelector((state) => state.payrun);
  const [state, setState] = useState(() => ({
    ...initialState,
    ...getMonthView(CALENDAR_MONTHS[0])
  }));

  const {
    data: employeeLOPData,
    isLoading: isEmployeesLoading,
    isFetching: isEmployeesFetching,
    refetch: employeeLOPRefetch
  } = useGetEmployeesLOPQuery({
    year: currentYear,
    month: state.month
  });
  const isEmployeesPending = isEmployeesLoading || isEmployeesFetching;

  const [updateLopCorrection] = useUpdateLopCorrectionMutation();

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(
      selectedPayrunTab === PAYROLL_CATEGORY.LOP ? updateLopFormSchema : updateOvertimeFormSchema
    ),
    values: {
      lop: state?.selectedLOPData?.lop || '',
      correctionLop: state?.selectedLOPData?.correctionLop || '0',
      correctionLopNotes: state?.selectedLOPData?.correctionLopNotes || '',
      overtime: state?.selectedLOPData?.overtime || '0',
      correctionOvertime: state?.selectedLOPData?.correctionOvertime || '',
      correctionOvertimeNotes: state?.selectedLOPData?.correctionOvertimeNotes || ''
    }
  });

  useEffect(() => {
    dispatch(handleYearChange(new Date().getFullYear()));
    dispatch(setSelectedPayrunTab(PAYROLL_CATEGORY.LOP));
  }, []);

  useEffect(() => {
    if (employeeLOPData)
      setState((prevPosts) => {
        // Here you can manipulate the previous state if needed
        return { ...prevPosts, employeesLopList: employeeLOPData };
      });
  }, [employeeLOPData]);

  useEffect(() => {
    employeeLOPRefetch();
  }, [currentYear, state.month]);

  let columnsT = [
    {
      name: LB_TBL_COL_MONTH,
      selector: (row) => <span className="payrun-name">{row.name || ''}</span>,
      sortable: false
    },
    {
      name: '',
      sortable: false,
      width: '72px',
      center: true,
      cell: (row) => (
        <button
          type="button"
          className={`row-action-menu__toggle ${state.row?.id === row.id ? 'is-open' : ''}`}
          title="View"
          aria-label="View"
          onClick={() => {
            setState((prevState) => ({
              ...prevState,
              ...getMonthView(row)
            }));
          }}
        >
          <i className="icofont-rounded-right" aria-hidden="true" />
        </button>
      )
    }
  ];

  let columnsLOPOvertimeEmp = [
    {
      name: 'Employee Name',
      selector: (row) => <span className="payrun-name">{row.userName || ''}</span>,
      sortable: false
    },
    {
      name: LB_TBL_COL_ACTION,
      sortable: false,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'Edit',
              icon: 'icofont-edit',
              variant: 'success',
              onClick: () => {
                setState({
                  ...state,
                  selectedLOPData: row,
                  selectedLopModel: true
                });
              },
              dataAttrs: {
                'data-bs-toggle': 'offcanvas',
                'data-bs-target': '#offcanvasRight',
                'aria-controls': 'offcanvasRight'
              }
            }
          ]}
        />
      )
    }
  ];

  if (selectedPayrunTab === PAYROLL_CATEGORY.LOP) {
    const lopCol = [
      {
        name: PAYROLL_CATEGORY.LOP,
        selector: (row) => (
          <span className={row.txtClass}>
            <span
              className={`position-relative ${row?.correctionLop > 0 ? 'text-decoration-line-through text-muted' : ''}`}
            >
              {row?.lop || '0'}
              {row?.correctionLop > 0 && (
                <span
                  className="position-absolute top-50 start-0 w-100"
                  style={{
                    height: '1px',
                    borderTop: '1px solid rgba(0, 0, 0, 0.3)', // Light black line
                    transform: 'translateY(-50%)'
                  }}
                ></span>
              )}
            </span>
          </span>
        ),
        sortable: false
      },
      {
        name: `Corrected ${PAYROLL_CATEGORY.LOP}`,
        selector: (row) => (
          <div className="d-flex justify-content-center align-items-center">
            <span>{row?.correctionLop || row?.correctionLop === 0 ? row.correctionLop : '-'}</span>
          </div>
        ),
        sortable: false
      },
      {
        name: 'Notes',
        selector: (row) => (
          <span className={`${row.txtClass} text-break`}>{row?.correctionLopNotes || '-'}</span>
        ),
        sortable: false
      }
    ];
    columnsLOPOvertimeEmp.splice(1, 0, ...lopCol);
  } else if (selectedPayrunTab === PAYROLL_CATEGORY.OVERTIME) {
    const lopCol = [
      {
        name: PAYROLL_CATEGORY.OVERTIME,
        selector: (row) => (
          <span className={row.txtClass}>
            <span
              className={`position-relative ${row?.correctionOvertime > 0 ? 'text-decoration-line-through text-muted' : ''}`}
            >
              {row?.overtime || '0'}
              {row?.correctionOvertime > 0 && (
                <span
                  className="position-absolute top-50 start-0 w-100"
                  style={{
                    height: '1px',
                    borderTop: '1px solid rgba(0, 0, 0, 0.3)', // Light black line
                    transform: 'translateY(-50%)'
                  }}
                ></span>
              )}
            </span>
          </span>
        ),
        sortable: false
      },
      {
        name: `Corrected ${PAYROLL_CATEGORY.OVERTIME}`,
        selector: (row) => (
          <div className="d-flex justify-content-center align-items-center">
            <span>
              {row?.correctionOvertime || row?.correctionOvertime === 0
                ? row.correctionOvertime
                : '-'}
            </span>
          </div>
        ),
        sortable: false
      },
      {
        name: 'Notes',
        selector: (row) => (
          <span className={`${row.txtClass} text-break`}>
            {row?.correctionOvertimeNotes || '-'}
          </span>
        ),
        sortable: false
      }
    ];
    columnsLOPOvertimeEmp.splice(1, 0, ...lopCol);
  }

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  /* const generateExcel = () => {
    const STATIC_LOP_DATA = [
      {
        'Employee No': 2,
        'LOP Days': 0
      },
      {
        'Employee No': 5,
        'LOP Days': 0
      }
    ];

    let payload = state.employeesLopList?.data
      ? state.employeesLopList?.data?.map((v) => {
          return {
            'Employee No': v?.user?.zohoEmployeeId,
            'LOP Days': v?.correctionLop > 0 ? v?.correctionLop : v?.lop ? v.lop : 0
          };
        })
      : [];

    payload = [...STATIC_LOP_DATA, ...payload];

    const worksheet = XLSX.utils.json_to_sheet(payload);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate Excel file and download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'EmployeeLops.xlsx');
  }; */

  // const generateCSV = () => {
  //   const STATIC_LOP_DATA = [
  //     { 'Employee No': 2, 'LOP Days': 0 },
  //     { 'Employee No': 5, 'LOP Days': 0 }
  //   ];

  //   let payload = state.employeesLopList?.data
  //     ? state.employeesLopList?.data?.map((v) => ({
  //         'Employee No': v?.user?.zohoEmployeeId,
  //         'LOP Days': v?.correctionLop > 0 ? v?.correctionLop : v?.lop ? v.lop : 0
  //       }))
  //     : [];

  //   payload = [...STATIC_LOP_DATA, ...payload];

  //   const worksheet = XLSX.utils.json_to_sheet(payload);
  //   const csvContent = XLSX.utils.sheet_to_csv(worksheet);

  //   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //   saveAs(blob, 'EmployeeLops.csv');
  // };

  const generateCSV = () => {
    let STATIC_DATA = [];

    if (selectedPayrunTab === PAYROLL_CATEGORY.LOP) {
      STATIC_DATA = [
        { 'Employee No': 2, 'LOP Days': 0 },
        { 'Employee No': 5, 'LOP Days': 0 }
      ];
    } else if (selectedPayrunTab === PAYROLL_CATEGORY.OVERTIME) {
      STATIC_DATA = [
        { 'Employee No': 2, 'Overtime Hours': 0 },
        { 'Employee No': 5, 'Overtime Hours': 0 }
      ];
    }

    let payload = state.employeesLopList?.data
      ? state.employeesLopList?.data?.map((v) => {
          if (selectedPayrunTab === PAYROLL_CATEGORY.LOP) {
            return {
              'Employee No': v?.user?.zohoEmployeeId,
              'LOP Days':
                v?.correctionLop || v?.correctionLop === 0 ? v.correctionLop : v?.lop ? v.lop : 0
              // 'LOP Days': v?.correctionLop > 0 ? v?.correctionLop : v?.lop ? v.lop : 0
            };
          } else if (selectedPayrunTab === PAYROLL_CATEGORY.OVERTIME) {
            return {
              'Employee No': v?.user?.zohoEmployeeId,
              'Overtime Hours':
                v?.correctionOvertime || v?.correctionOvertime === 0
                  ? v.correctionOvertime
                  : v?.overtime
                    ? v.overtime
                    : 0
              // v?.correctionOvertime > 0 ? v?.correctionOvertime : v?.overtime ? v.overtime : 0 // Assuming a function to calculate overtime
            };
          }
        })
      : [];

    payload = [...STATIC_DATA, ...payload];

    const worksheet = XLSX.utils.json_to_sheet(payload);
    const csvContent = XLSX.utils.sheet_to_csv(worksheet);

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(
      blob,
      `${CALENDAR_MONTHS[state.month - 1]?.name ? `${CALENDAR_MONTHS[state.month - 1].name}-` : ''}${currentYear}_${selectedPayrunTab}_Employee.csv`
    );
  };

  const closeCorrectionModal = () => {
    setState((prevState) => ({
      ...prevState,
      selectedLOPData: null,
      selectedLopModel: false
    }));
  };

  const handleResetState = () => {
    reset();
    setState({
      ...state,
      isModal: { model: false, submit: false },
      loading: false,
      modalHeader: { title: '', isEdit: false, editId: '' },
      selectedLOPData: null,
      selectedLopModel: false,
      month: null,
      year: null
    });
  };

  const renderModalForm = () => (
    <div className="payrun-modal__section">
      <div className="payrun-modal__grid">
        <div className="payrun-modal__field">
          <label
            htmlFor={selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime'}
            className="payrun-modal__label"
          >
            {selectedPayrunTab === PAYROLL_CATEGORY.LOP ? LB_LOP : LB_OVERTIME}
          </label>
          <input
            id={selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime'}
            type="text"
            {...register(selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime')}
            className="form-control payrun-modal__input"
            placeholder={selectedPayrunTab === PAYROLL_CATEGORY.LOP ? PH_LOP : PH_OVERTIME}
            value={
              state?.selectedLOPData?.[
                selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime'
              ] ||
              state?.selectedLOPData?.[
                selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime'
              ] === 0
                ? state.selectedLOPData[
                    selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime'
                  ]
                : '0'
            } // Use defaultValue for uncontrolled input
            disabled={true} // Ensure this is intentional
          />
          <small className="text-danger payrun-modal__error">
            {getErrorMessage(
              selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'lop' : 'overtime',
              errors
            )}
          </small>
        </div>
        <div className="payrun-modal__field">
          <label
            htmlFor={
              selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'correctionLop' : 'correctionOvertime'
            }
            className="payrun-modal__label"
          >
            {selectedPayrunTab === PAYROLL_CATEGORY.LOP
              ? LB_CORRECTION_LOP
              : LB_CORRECTION_OVERTIME}
          </label>
          <input
            id={selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'correctionLop' : 'correctionOvertime'}
            type="text"
            {...register(
              selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'correctionLop' : 'correctionOvertime'
            )}
            className="form-control payrun-modal__input"
            placeholder={
              selectedPayrunTab === PAYROLL_CATEGORY.LOP
                ? PH_CORRECTION_LOP
                : PH_CORRECTION_OVERTIME
            }
            // value={state?.selectedLOPData?.correctionLop || ''} // Use defaultValue for uncontrolled input
          />
          <small className="text-danger payrun-modal__error">
            {getErrorMessage(
              selectedPayrunTab === PAYROLL_CATEGORY.LOP ? 'correctionLop' : 'correctionOvertime',
              errors
            )}
          </small>
        </div>
      </div>
      <div className="payrun-modal__field">
        <label htmlFor="exampleFormControlTextarea78d" className="payrun-modal__label">
          {LB_CORRECTION_NOTES}
        </label>
        <textarea
          className="form-control payrun-modal__textarea"
          placeholder={PH_CORRECTION_NOTES}
          {...register(
            selectedPayrunTab === PAYROLL_CATEGORY.LOP
              ? 'correctionLopNotes'
              : 'correctionOvertimeNotes'
          )}
          id="exampleFormControlTextarea78d"
          rows="3"
        ></textarea>
        <small className="text-danger payrun-modal__error">
          {getErrorMessage(
            selectedPayrunTab === PAYROLL_CATEGORY.LOP
              ? 'correctionLopNotes'
              : 'correctionOvertimeNotes',
            errors
          )}
        </small>
      </div>
    </div>
  );

  const onSubmit = (data) => {
    handleCorrectedLopOvertime(data, state.selectedLOPData?._id);
  };

  const handleCorrectedLopOvertime = async (data, id) => {
    try {
      const editData = {
        data,
        id
      };

      setState({ ...state, loading: true });

      const { data: resData, error } = await updateLopCorrection(editData);

      if (resData?.success) {
        notification(resData.statusMessage, TOAST_SUCCESS);
        handleResetState();
      } else if (error) {
        handleApiError(error);
        handleResetState();
      }
    } catch (error) {
      notification(error?.message, TOAST_ERROR);
      handleResetState();
    }
  };

  return (
    <>
      <div className="container-xxl payrun-page">
        <PageHeader headerTitle="Payrun" />

        <div className="flex clearfix gap-3 payrun-page__body">
          <TableCard className="payrun-page__card">
            <div className="app-table-toolbar app-table-toolbar--payrun">
              <ul className="nav nav-pills payrun-tabs" role="group" aria-label="Payrun type">
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${selectedPayrunTab === LOP ? 'active' : ''}`}
                    onClick={() => {
                      dispatch(setSelectedPayrunTab(LOP));
                    }}
                    title={`${LOP} View`}
                  >
                    <i className="icofont-minus-circle" aria-hidden="true"></i>
                    <span>{LOP}</span>
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${selectedPayrunTab === OVERTIME ? 'active' : ''}`}
                    onClick={() => {
                      dispatch(setSelectedPayrunTab(OVERTIME));
                    }}
                    title={`${OVERTIME} View`}
                  >
                    <i className="icofont-clock-time" aria-hidden="true"></i>
                    <span>{OVERTIME}</span>
                  </button>
                </li>
              </ul>
              <div className="app-table-year-picker" role="group" aria-label="Select year">
                <button
                  type="button"
                  onClick={() => {
                    if (currentYear > KPI_START_YEAR) {
                      dispatch(handleYearChange(currentYear - 1));
                    }
                  }}
                  title="Previous year"
                  className="app-table-year-picker__nav"
                  disabled={KPI_START_YEAR >= currentYear ? true : false}
                >
                  <i className="icofont-rounded-left"></i>
                </button>
                <span className="app-table-year-picker__value">{currentYear || ''}</span>
                <button
                  type="button"
                  onClick={() => {
                    dispatch(handleYearChange(currentYear + 1));
                  }}
                  title="Next year"
                  className="app-table-year-picker__nav"
                >
                  <i className="icofont-rounded-right"></i>
                </button>
              </div>
            </div>

            <div className={`payrun-split ${state.row ? 'is-open' : ''}`}>
              <div className="payrun-split__months">
                <div className="payrun-split__months-sticky">
                  <div className="card-body">
                    <DataTable
                      customStyles={payrunTableStyles}
                      title={'Payrun'}
                      columns={columnsT}
                      data={CALENDAR_MONTHS || []}
                      defaultSortField="title"
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      selectableRows={false}
                      noDataComponent={<EmptyData />}
                      className="payrun-table table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                      highlightOnHover={true}
                      progressPending={false}
                      progressComponent={<TableSkeleton columns={6} />}
                      conditionalRowStyles={[
                        {
                          when: (row) => state.row?.id === row.id,
                          style: {
                            backgroundColor: '#eef0f8'
                          }
                        }
                      ]}
                    />
                  </div>
                </div>
              </div>
              {state.row && (
                <div className="payrun-split__detail">
                  <div className="payrun-panel">
                    <div className="payrun-panel__header">
                      <div className="payrun-panel__header-content">
                        <span className="payrun-panel__icon">
                          <i className="icofont-users-alt-5" aria-hidden="true"></i>
                        </span>
                        <div className="payrun-panel__copy">
                          <h4 className="payrun-panel__title" id="offcanvasRightLabel">
                            All Employees {`${selectedPayrunTab ? `- ${selectedPayrunTab}` : ''}`}
                          </h4>
                          <p className="payrun-panel__meta">
                            {state?.month &&
                              currentYear &&
                              moment()
                                .month(state.month - 1)
                                .format('MMMM')}{' '}
                            {currentYear}
                          </p>
                        </div>
                      </div>
                      <div className="payrun-panel__header-actions">
                        <button
                          type="button"
                          disabled={
                            isEmployeesPending || !(state.employeesLopList?.data?.length > 0)
                          }
                          onClick={generateCSV}
                          className="payrun-panel__download"
                        >
                          <i className="icofont-download" aria-hidden="true"></i>
                          CSV
                        </button>
                      </div>
                    </div>
                    <div className="payrun-panel__body">
                      <div className="payrun-panel__card">
                        <DataTable
                          customStyles={payrunTableStyles}
                          title={'Payrun'}
                          columns={columnsLOPOvertimeEmp}
                          data={state.employeesLopList?.data || []}
                          defaultSortField="title"
                          onChangePage={handleChangePage}
                          onChangeRowsPerPage={handleChangeRowsPerPage}
                          selectableRows={false}
                          noDataComponent={<EmptyData />}
                          className="payrun-table table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                          highlightOnHover={true}
                          progressPending={isEmployeesPending}
                          progressComponent={<TableSkeleton columns={5} />}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </TableCard>
        </div>
      </div>

      {state?.selectedLopModel && (
        <Modal
          centered
          show={state.selectedLopModel}
          onHide={closeCorrectionModal}
          backdrop={false}
          dialogClassName="payrun-modal__dialog"
          contentClassName="payrun-modal__content"
        >
          <form className="payrun-modal__form" onSubmit={handleSubmit(onSubmit)}>
            <div className="payrun-modal__header">
              <div className="payrun-modal__header-content">
                <span className="payrun-modal__header-icon">
                  <i className="icofont-edit" aria-hidden="true"></i>
                </span>
                <div className="payrun-modal__header-copy">
                  <h5 className="payrun-modal__title" id="dremovetaskLabel">
                    Update {selectedPayrunTab} Correction
                  </h5>
                  <p className="payrun-modal__subtitle">
                    {state?.selectedLOPData?.userName}
                    {state?.selectedLOPData?.monthName
                      ? ` - ${state.selectedLOPData.monthName}${state?.selectedLOPData?.year ? ` ${state.selectedLOPData.year}` : ''}`
                      : ''}
                  </p>
                </div>
              </div>
              <button
                type="button"
                className="btn-close payrun-modal__close"
                aria-label="Close"
                onClick={closeCorrectionModal}
              ></button>
            </div>
            <Modal.Body className="payrun-modal__body">{renderModalForm()}</Modal.Body>
            <Modal.Footer className="payrun-modal__footer">
              <button type="submit" disabled={state.loading} className="btn payrun-modal__submit">
                {state.loading ? (
                  <div className="spinner-border spinner-border-sm" role="status"></div>
                ) : (
                  BTN_SAVE
                )}
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      )}
    </>
  );
};

export default Payrun;
